import { IPhase } from 'redux-store/types';
export interface PhaseItemDateRange {
  startDate: string;
  endDate: string;
  workDays: number;
}

export interface PhaseItemsState {
  dateRangesById: Record<number, PhaseItemDateRange>;
}

export function getPhaseItemsStartEndDates(phases: IPhase[]): PhaseItemsState['dateRangesById'] {
  return phases.reduce(
    (acc, phase) => {
      if (!Array.isArray(phase.items)) return acc;

      phase.items.forEach((item) => {
        acc[item.id] = {
          startDate: item.startDate,
          endDate: item.endDate,
          workDays: item.workDays,
        };
      });

      return acc;
    },
    {} as PhaseItemsState['dateRangesById']
  );
}
